export default Object.freeze({
    DIRECT: 'direct',
    MATCH: 'match',
})
